/**
 * Record a shopper's applied attribute filters as a taste signal, in both
 * places affinity is read from:
 *
 * - this visit's interest vector (utils/session-interest.ts), which the home
 *   rows and similar listings send to the server as `affinity`, and
 * - ClickHouse, as `filter_facet_selected`, which the per-buyer readers fold
 *   into For You across visits (utils/recommendations.ts).
 *
 * Only brand, size, colour, gender, age and material count: price, condition
 * and the toggles narrow a search without saying anything about taste. Called
 * on Apply, the committed choice, not on each tap in the drawer.
 */

import { getAnalytics } from './analytics';
import { recordInterest } from './session-interest';
import { facetAffinityTokens, facetSearchFilters } from './facet-affinity';
import type { FilterState } from './search-filter-state';

export function recordFacetSelection(
  filters: FilterState,
  context: { query?: string; categoryId?: number; categoryGroupId?: number } = {}
): void {
  const tokens = facetAffinityTokens(filters);
  if (tokens.length === 0) return;

  recordInterest({ signal: 'facet', tags: tokens, categoryGroupId: context.categoryGroupId });
  getAnalytics()?.facetSelected({
    searchFilters: facetSearchFilters(filters),
    tokens,
    query: context.query,
    categoryId: context.categoryId,
    categoryGroupId: context.categoryGroupId,
  });
}
